export enum NovapostCargoTypeEnum {
    CARGO = 'Cargo',
    DOCUMENTS = 'Documents',
    TIRES_WHEELS = 'TiresWheels',
    PALLET = 'Pallet',
    PARCEL = 'Parcel'
}
